import Tabs from "@/v2-backoffice-client/components/tabs"
import { useUnlicensedCustomersQuery } from "@/v2-backoffice-client/license/unlicensed/license.unlicensed.query"
import { LICENSING_VIEW_UNLICENSED_USAGE } from "@/v2-backoffice-client/license/license.constants"

// The Licensing page's Unlicensed Usage tab trigger: how many customers have
// live users and no covering license. Owns its own read of the query —
// Apollo dedupes it against the board's — so the count stays live no matter
// which tab is open.
function LicenseUnlicensedTabTrigger() {
  const { data, loading } = useUnlicensedCustomersQuery()
  const unlicensedCustomerCount = (data?.getUnlicensedCustomers ?? []).length

  return (
    <Tabs.Trigger
      value={LICENSING_VIEW_UNLICENSED_USAGE}
      iconSrc="triangle-warning"
      isLoading={loading}
      count={unlicensedCustomerCount}
    >
      Unlicensed Usage
    </Tabs.Trigger>
  )
}

export default LicenseUnlicensedTabTrigger
